import  './herobanner.scss'
import {images} from '../../constants'

const HeroBanner = () => {
  return (
    <div className='app_hero-main'>
      <h4>India's first end-to-end products and services platform focused on Woman's health journey</h4>
      <h2>Let's make women health a priority!</h2>
      <div className='app_hero_img_container'>
        <img src='https://cdn.storehippo.com/s/6123687a0e3882eabaee1e6e/ms.files/Final Land 1.png' alt='hero 1'/>
        <img src='https://cdn.storehippo.com/s/6123687a0e3882eabaee1e6e/ms.files/Final Land 2.png' alt='hero 2'/>
        <img src='https://cdn.storehippo.com/s/6123687a0e3882eabaee1e6e/ms.files/Final land 3.png' alt='hero 3'/>
        <img src='https://cdn.storehippo.com/s/6123687a0e3882eabaee1e6e/ms.files/Final Land 4.png' alt='hero 4'/>
      </div>
      <div className='app_stats_div'>
        <div className='app_stats_item'>
          <img src={images.ServicesIcon} alt='services-icon'/>
          <p>12K+ Products & Services</p>
        </div>  
        <div className='app_stats_item'>
          <img src={images.CategoriesHero} alt='categories'/>
          <p>40+ Categories</p>
        </div>  
        <div className='app_stats_item'>
          <img src={images.MarketFirst} alt='market-first'/>
          <p>Market 1st Offerings</p>
        </div>  
        <div className='app_stats_item'>
          <img src={images.PandS} alt='p-and-s'/>
          <p>140+ Brands You Can Trust</p>
        </div>  
        <div className='app_stats_item'>
          <img src={images.PanIndia} alt='pan-india'/>
          <p>Pan India Operations</p>
        </div>  
        <div className='app_stats_item'>
          <img src={images.ServicesIcon6} alt='services-icon-6'/>
          <p>Experts Speak 10+ Languages</p>
        </div>  
      </div>
    </div>
  )
}

export default HeroBanner